import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'player-position-filter',
    templateUrl: './player-position-filter.modal.html',
    styleUrls: ['./player-position-filter.modal.scss'],
})
export class PlayerPositionFilterModal implements OnInit{
    
    @Input() filters: any;

    constructor(public activeModal: NgbActiveModal) {}
    
    ngOnInit(): void {
    }

    toggleGk() {
        this.filters.gk = !this.filters.gk;
    }

    toggleSW() {
        this.filters.sw = !this.filters.sw;
      }

    toggleDF() {
        this.filters.df = !this.filters.df;
    }

    toggleDM() {
        this.filters.dm = !this.filters.dm;
    }

    toggleMF() {
        this.filters.mf = !this.filters.mf;
    }

    toggleAM() {
        this.filters.am = !this.filters.am;
    }

    toggleFW() {
        this.filters.fw = !this.filters.fw;
    }

    toggleL() {
        this.filters.l = !this.filters.l;
    }

    toggleC() {
        this.filters.c = !this.filters.c;
    }

    toggleR() {
        this.filters.r = !this.filters.r;
    }

    submit() {
        this.activeModal.close(this.filters);
    }
}